import React from 'react';
import './index.css';
import { Button, Image } from 'react-bootstrap';
import { BsArrowRight, BsCheckLg } from 'react-icons/bs';

const AboutUs = () => {
  return (
    <div className='section about-wrapper'>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='row'>
              <div className='col-xl-3 col-lg-6 col-md-6 col-12'>
                <div className='feature-overview'>
                  <div className='feature-icon'>
                    <Image src='images/icons/feature-1.png' width={45} />
                  </div>
                  <h4>Smart Lead Management</h4>
                  <p>Capture, track & convert leads seamlessly.</p>
                </div>
              </div>
              <div className='col-xl-3 col-lg-6 col-md-6 col-12'>
                <div className='feature-overview'>
                  <div className='feature-icon'>
                    <Image src='images/icons/feature-2.png' width={45} />
                  </div>
                  <h4>Easy Booking & Installments</h4>
                  <p>Flexible payment plans for customers.</p>
                </div>
              </div>
              <div className='col-xl-3 col-lg-6 col-md-6 col-12'>
                <div className='feature-overview'>
                  <div className='feature-icon'>
                    <Image src='images/icons/feature-3.png' width={45} />
                  </div>
                  <h4>Real-Time Financial Reports</h4>
                  <p>Gain insights & optimize business growth.</p>
                </div>
              </div>
              <div className='col-xl-3 col-lg-6 col-md-6 col-12'>
                <div className='feature-overview'>
                  <div className='feature-icon'>
                    <Image src='images/icons/feature-4.png' width={45} />
                  </div>
                  <h4>Secure & Scalable</h4>
                  <p>Built for real estate agencies of all sizes.</p>
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex align-items-center justify-content-center' id='about'>
            <hr className='w-85 hr' />
          </div>
          <div className='col-xl-6 col-lg-12 col-md-12'>
            <div className='about-image'>
              <Image src='images/about/about-img.webp' width={"100%"} />
            </div>
          </div>
          <div className='col-xl-6 col-lg-12 col-md-12'>
            <div className='about-info'>
              <h2>About Us</h2>
              <p>Empowering Real Estate Businesses with Smart CRM Solutions</p>

              <div className='about-content'>
                <p>On9Estate powered by Appzito Technologies, we help real estate businesses streamline their operations with a powerful CRM designed for lead management, booking automation, and financial insights. Our mission is to make property sales, customer interactions, and financial tracking effortless, so you can focus on growth.</p>
              </div>

              <div className='mt-4'>
                <h4>Why Choose Us?</h4>
                <ul className='list-unstyled text-secondary mb-4'>
                  <li className='mb-1'>
                    <BsCheckLg size={16} />
                    <span className='ms-2'><span className='fw-600'>Proven Success</span> - Trusted by many real estate companies worldwide.</span>
                  </li>
                  <li className='mb-1'>
                    <BsCheckLg size={16} />
                    <span className='ms-2'><span className='fw-600'>All-in-One Solution</span> - From lead generation to financial reporting.</span>
                  </li>
                  <li className='mb-1'>
                    <BsCheckLg size={16} />
                    <span className='ms-2'><span className='fw-600'>User-Friendly & Scalable</span> - Built for agencies, developers, and brokers.</span>
                  </li>
                </ul>
                <p className='text-dark'>Join the future of real estate management and scale your business today!</p>
                <div className='w-100 d-flex align-items-center justify-content-center justify-content-xl-start'>
                  <Button variant='outline-primary' className='bg-transparent'>
                    <div className='d-flex align-items-center'>
                      <span className='me-3'>Discover More</span>
                      <BsArrowRight size={18} />
                    </div>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutUs;
